import type { Observable } from 'rxjs';

import type { AuthSession, Credentials } from '@domain/models/auth.model';

export abstract class AuthRepository {
  abstract login(credentials: Credentials): Observable<AuthSession>;
  abstract logout(): Observable<void>;
  abstract restoreSession(): AuthSession | null;
  abstract persistSession(session: AuthSession): void;
  abstract clearSession(): void;
}
